import devConfigs from './dev_env'
import prodConfigs from './prod_env'
import localConfigs from './local_env'

class EnvConfig {

    constructor() {
        if(process.env.REACT_APP_ENV === "production"){
            this.config = prodConfigs;
        }
        else if(process.env.REACT_APP_ENV === "local"){
            this.config = localConfigs;
        }
        else{
            this.config = devConfigs;
        }
    }

    static getConfig() {
        if(process.env.REACT_APP_ENV === "production"){
            return prodConfigs;
        }
        else if(process.env.REACT_APP_ENV === "local"){
            return localConfigs;
        }
        else{
            return devConfigs;
        }
    }
}

export default EnvConfig;